import { CartItem } from '../types/Product'
import { formatPriceInFractionalCurrency } from '../utils/formatting'
import { Currency, Locale } from '../types/locale'
import { getCartItemPrice } from '../utils/checkout'
import { stripSupTagFromText } from '../utils/htmlReactParserWrapper'

export const replaceDigitalDataChars = (str: string) => {
  return str.replace(/.00$|\$|,|\||;|;|®/gm, '')
}

export const buildDigitalDataProductDetails = (
  items: CartItem[],
  currency: Currency,
  locale: Locale,
) => {
  return items.map((item) => {
    const itemPrice = getCartItemPrice(item, currency)
    return {
      SKU: item.id?.toLowerCase() || 'no-sku',
      name: stripSupTagFromText(item.name).toLowerCase() || 'no-name',
      category: item.metadata?.Product_Category.toLowerCase(),
      subCategory: item.metadata?.Product_Sub_Category.toLowerCase(),
      nameplate: 'no-nameplate',
      modelYear: 'no-my',
      quantity: item.quantity?.toString(),
      unitPrice: replaceDigitalDataChars(
        formatPriceInFractionalCurrency(itemPrice, currency, locale),
      ),
      unitPriceDiscounted: '0',
      unitDiscountAmount: '0',
      totalInstallationCost: '0',
      totalCost: replaceDigitalDataChars(
        formatPriceInFractionalCurrency(
          item.quantity * itemPrice,
          currency,
          locale,
        ),
      ),
      installationType: 'no-labor',
      availability: 'in-stock',
      discountCode: 'no-discount-code',
    }
  })
}
